import React from 'react'
import PropTypes from 'prop-types'
import PrimaryButton from '../../../PrimaryButton'
import SecondaryButton from '../../../SecondaryButton'

const propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  selectedItem: PropTypes.string,
  onChange: PropTypes.func,
}

const defaultProps = {
  items: [],
  selectedItem: '',
}

const ButtonGroup = ({ items, selectedItem, onChange }) => {
  return (
    <div className="flex flex-wrap items-center -mx-1">
      {items.map((item, index) => {
        let { text, value } = item
        return (
          <div
            className="flex flex-col flex-auto px-1 py-2 text-sm sm:flex-row sm:flex-none min-w-6/12 sm:min-w-0"
            key={value}
          >
            {item.value === selectedItem ? (
              <SecondaryButton
                rounded
                onClick={() => onChange(value)}
                cy={text}
              >
                {text}
              </SecondaryButton>
            ) : (
              <PrimaryButton
                light
                rounded
                onClick={() => onChange(value)}
                cy={text}
              >
                {text}
              </PrimaryButton>
            )}
          </div>
        )
      })}
    </div>
  )
}

ButtonGroup.propTypes = propTypes
ButtonGroup.defaultProps = defaultProps

export default ButtonGroup
